import React from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import BharathidasanUniversityDetails from './section-components/bharathidasan-university-details';
import Footer from './global-components/footer-v2';
import {Helmet} from "react-helmet";

const BharathidasanUniversity = () => {
    return <div>
        <Navbar />
        <Helmet>
            <title>Distance Education by Bharathidasan University | MIET Chennai</title>
            <meta name="description" content="MIET Education, one of the leading distance education provider in India offers Bharathidasan University Distance Education Courses." />
        </Helmet>
        <PageHeader headertitle="Bharathidasan University"  />
        <BharathidasanUniversityDetails />
        <Footer />
    </div>
}

export default BharathidasanUniversity